module.exports = __webpack_public_path__ + "media/request_a_demo/img1-5d3dc157.png";